import Vue from 'vue';
import Vuex from 'vuex';

import environments from './modules/environments';
import templates from './modules/templates';
import user from './modules/user'
import snackbar from './modules/snackbar'
import settings from './modules/settings'
import estimatedCost from './modules/estimatedCost'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    environments,
    templates,
    user,
    snackbar,
    settings,
    estimatedCost
  }
})